import { render, staticRenderFns } from "./ScreenCodigosBusqueda.vue?vue&type=template&id=af17d1aa"
import script from "./ScreenCodigosBusqueda.vue?vue&type=script&lang=js"
export * from "./ScreenCodigosBusqueda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports